import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import React, { useEffect, useRef, useState } from "react";
import "react-phone-number-input/style.css";
import { useDispatch, useSelector } from "react-redux";

import {selectUsers, updatePassword} from "../users/usersSlice";
import {Typography} from "@material-ui/core";
import AuthDialog from "../auth/AuthDialog";
import {validatePassword} from "../../common/validators";

const ColorButton = withStyles((theme) => ({
  root: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: theme.palette.secondaryButton.main,
    color: theme.palette.secondaryButtonFont.main,
    borderRadius: "24px",
    "&:hover": {
      backgroundColor: theme.palette.secondaryButton.main,
      opacity: 0.7,
    },
  },
}))(Button);
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  getContentAnchorEl: null,
};
const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "45px",
    // backgroundColor: theme.palette.secondary.main,
    width: "100%",
  },
  accountContainer: {
    height: "100%",
    color: theme.palette.primaryFont.main,
  },
  topBackground: {
    // backgroundColor: theme.palette.secondary.main,
    // height: '100%',
  },
  form: {
    // borderBottom: '1px solid rgb(221, 221, 221)',

    marginTop: theme.spacing(1),
    width: "100%", // Fix IE 11 issue.
    color: theme.palette.secondaryFont.main,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
  },
  registerContainer: {
    borderRadius: 16,
    backgroundColor: "#fff",
    color: theme.palette.secondaryFont.main,
    padding: "50px !important",
  },
  textLabel: {
    fontSize: 20,
    fontWeight: "bold",
    marginBottom: 4,
    marginTop: 8,
  },
  textInput: {},
  userDetailsContainer: {
    padding: 24,
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "space-between",
  },
  userDetails: {
    display: "flex",
    justifyContent: "space-between",
    // color: "#fff",
    fontSize: 40,
  },
  infoContainerEdit: {
    display: "flex",
    flexFlow: "column wrap",
    justifyContent: "space-between",
    marginLeft: 80,
  },

  userCardsContainerEdit: {
    display: "flex",
    flexFlow: "row wrap",
    padding: 24,
    boxSizing: "border-box",
    justifyContent: "space-between",
    flexGrow: 1,
    width: "100%",
  },
  historyCardContainerEdit: {
    display: "flex",
    flexGrow: 1,
    marginRight: 80,

    // padding: 24,
    // boxSizing: 'border-box',
  },
  historyCardEdit: {
    // display: 'flex',
    flexGrow: 1,
    padding: 24,
    borderRadius: 16,
  },
  cardHeader: {
    color: theme.palette.primaryFont.main,
    fontWeight: "bold",
    fontSize: 40,
  },
  formControl: {
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.palette.primaryFont.main,
    borderRadius: 16,
    display: "flex",
    marginTop: 12,
  },
}));

const usePlaceholderStyles = makeStyles((theme) => ({
  placeholder: {
    color: theme.palette.primaryFont.main,
  },
}));

const Placeholder = ({ children }) => {
  const classes = usePlaceholderStyles();
  return <div className={classes.placeholder}>{children}</div>;
};

export default function MemberPasswordReset(props) {
  const classes = useStyles();
  let jwtToken = localStorage.getItem("clientToken");

  const dispatch = useDispatch();

  const { userAccount, user } = useSelector(selectUsers);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmError, setConfirmError] = useState("");

  const handlePasswordSubmit = (event) => {
    event.preventDefault();

    const passwordUpdate = {
      newPassword: newPassword,
      auth_role: userAccount.roleID,
    };

    if (!validatePassword(newPassword)) {
      setPasswordError("Invalid password - insufficient complexity");
    } else if (newPassword !== confirmPassword) {
      setConfirmError("Passwords don't match");
    } else {
      setPasswordError("");
      setConfirmError("");
      dispatch(
          updatePassword({
            id: user.id,
            token: jwtToken,
            passwordUpdate: passwordUpdate,
          })
      );
    }
  };

  return (
      <Grid className={classes.historyCardEdit}>
        <form className={classes.form} onSubmit={handlePasswordSubmit}>
          <div className={classes.userDetails}>
            <div>
              Reset password for {user.displayName}
            </div>
          </div>
          <Grid>
            <Typography>
              New password must be at least 8 characters and contain at least one uppercase letter,
              one lowercase letter and one number.
            </Typography>
          </Grid>
          <div className={classes.textLabel}>New password: </div>
          <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="new-password"
              label="New Password"
              type="password"
              id="new-password"
              autoComplete="new-password"
              onChange={(e) => setNewPassword(e.target.value)}
              error={passwordError !== ""}
              helperText={passwordError ? passwordError : ""}
          />
          <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="confirm-password"
              label="Confirm Password"
              type="password"
              id="confirm-password"
              autoComplete="new-password"
              onChange={(e) => setConfirmPassword(e.target.value)}
              error={confirmError !== ""}
              helperText={confirmError ? confirmError : ""}
          />
          <ColorButton type="submit" fullWidth variant="contained">
            Reset Password
          </ColorButton>
        </form>
      </Grid>
  );
}
